export const getUsersOptions = (value, id) => ({
	with: ['roles', 'provider'],
	search: {
		searchText: encodeURIComponent(value) || null,
		provider_id: id,
	},
	searchFields: {
		searchText: 'ilike',
		provider_id: '=',
	},
});

export const getProvidersParams = (value) => ({
	search: {
		name: encodeURIComponent(value) || null,
	},
	searchFields: {
		name: 'ilike',
	},
});

export const getProvider = () => ({
	append: 'users_by_roles',
});
